import React from 'react';

export default function Footer()
{
    return (
        <footer>
            <p>&copy; CS467 Fall 2024</p>
        </footer>
    );
}